import isEmpty from "lodash/isEmpty";
import type { IProductLean } from "../../../pages/ProductsListPage/entities/product-lean/product-lean.entity.interface";
import { isArrayFilled } from "../../../utils/isArrayFilled";

export function isFoundNothing(searchText: string, services: IProductLean[]) {
  if (isSerchTextFilled(searchText) && !isArrayFilled(services)) {
    return true;
  }

  return false;
}

export function isSomethingFound(searchText: string, services: IProductLean[]) {
  if (isSerchTextFilled(searchText) && isArrayFilled(services)) {
    return true;
  }

  return false;
}

export function isSerchTextFilled(searchText: string) {
  return !isEmpty(searchText);
}
